/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Photo Upload',
  definitions: {
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            fillRule="evenodd"
            d="M9.552 20.434l-1.27.192C6 20.972 4.25 22.944 4.25 25.323A4.75 4.75 0 0 0 9 30.073h2.96c.345 0 .625.28.625.625s-.28.625-.625.625H9.926 9.92 9a6 6 0 0 1-6-6c0-2.892 2.047-5.307 4.77-5.874l.324-.058-.049-.326A6.06 6.06 0 0 1 8 18.323a6 6 0 0 1 6-6 6.03 6.03 0 0 1 1.047.091C16.923 8.234 21.122 5.323 26 5.323c6.295 0 11.459 4.848 11.96 11.014A7.5 7.5 0 0 1 45 23.823c0 3.974-3.091 7.226-7 7.484a7.64 7.64 0 0 1-.466.016h-1.478c-.345 0-.625-.28-.625-.625s.28-.625.625-.625h1.328v-.001l.115.001a6.25 6.25 0 0 0 .385-12.488l-1.082-.066-.088-1.081C36.265 10.915 31.639 6.573 26 6.573c-4.368 0-8.131 2.606-9.813 6.353l-.399.888-.958-.169c-.269-.047-.546-.072-.83-.072a4.75 4.75 0 0 0-4.75 4.75c0 .29.026.573.075.847l.227 1.265zm7.394 7.599c-.054-.2.065-.406.265-.459l13.523-3.623c.2-.054.406.065.459.265l2.847 10.625c.054.2-.065.406-.265.459l-13.523 3.624c-.2.054-.406-.065-.459-.265l-2.847-10.625zm-.058-1.667c-.867.232-1.381 1.123-1.149 1.99l2.847 10.625c.232.867 1.123 1.381 1.99 1.149l13.523-3.623c.867-.232 1.381-1.123 1.149-1.99l-2.847-10.625c-.232-.867-1.123-1.381-1.99-1.149l-13.523 3.623zm10.195 2.483c.311-.538.999-.722 1.537-.412l3.241 1.871c.299.172.401.555.229.854s-.555.401-.854.229l-3.133-1.809-3.577 6.195c-.173.299-.555.401-.854.229s-.401-.555-.229-.854l3.639-6.303zm-6.02 2.648c.311-.538.999-.723 1.537-.412l1.404.811c.299.173.401.555.229.854s-.555.401-.854.229l-1.296-.748-1.455 2.521c-.173.299-.555.401-.854.229s-.401-.555-.229-.854l1.518-2.629zm-7.132-3.032c.333-.089.676.108.766.442l2.883 10.759c.34 1.267 1.642 2.019 2.909 1.679l13.72-3.676c.333-.089.676.108.765.442s-.108.676-.442.765l-13.72 3.676c-1.934.518-3.922-.629-4.44-2.563l-2.883-10.759c-.089-.333.108-.676.442-.765zm10.128-16.585c.244-.244.64-.244.884 0l3.5 3.5c.244.244.244.64 0 .884s-.64.244-.884 0l-2.433-2.433v7.491c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-7.491l-2.433 2.433c-.244.244-.64.244-.884 0s-.244-.64 0-.884l3.5-3.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
